export default "__VITE_ASSET__45mN89$B__"